import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Movie } from '../../types/movie';

interface FilterParams {
  category?: string;
  genre?: string;
  year?: string;
  minScore?: number;
}

interface SearchState {
  keyword: string;
  filters: FilterParams;
  results: Movie[];
  loading: boolean;
  error: string | null;
}

const initialState: SearchState = {
  keyword: '',
  filters: {},
  results: [],
  loading: false,
  error: null,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setKeyword: (state, action: PayloadAction<string>) => {
      state.keyword = action.payload;
    },
    setFilters: (state, action: PayloadAction<FilterParams>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setResults: (state, action: PayloadAction<Movie[]>) => {
      state.results = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearSearch: (state) => {
      state.keyword = '';
      state.results = [];
      state.filters = {};
    },
  },
});

export const { 
  setKeyword, 
  setFilters, 
  setResults, 
  setLoading, 
  setError, 
  clearSearch 
} = searchSlice.actions;

export default searchSlice.reducer; 